import React, { useState } from "react";
import { FaShare } from "react-icons/fa";
import { IoHeartCircle } from "react-icons/io5";
import { IoChatbox } from "react-icons/io5";
import profilePicm from "../assets/images/avatar_man1.svg";
import profilePicf from "../assets/images/avatar_woman1.svg";
import profilePicC from "../assets/images/club_default_Image.svg";
import profilePicd from "../assets/images/club-list1-b.svg";
import post1 from "../assets/images/post1.svg";
import post2 from "../assets/images/post2.svg";
import post3 from "../assets/images/events1.svg";
import post4 from "../assets/images/events2.svg";
import post5 from "../assets/images/events3.svg";
import post6 from "../assets/images/image2.jpg";
import post7 from "../assets/images/image3.webp";
import Button from 'react-bootstrap/Button';
import { RiDeleteBin6Line } from "react-icons/ri";
import { LuPen } from "react-icons/lu";
import { IoPaperPlane } from "react-icons/io5";
import { BsStopwatch } from "react-icons/bs";
import { FaStar } from "react-icons/fa6";
import { MdDateRange } from "react-icons/md";
import { BsFillPeopleFill } from "react-icons/bs";
import { GrCheckmark } from "react-icons/gr";
import { useAuth } from "../context/AuthContext";
import { IoTicket } from "react-icons/io5";
import { IoPeople } from "react-icons/io5";
import { LiaAngleRightSolid } from "react-icons/lia";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import { IoLogoUsd } from "react-icons/io";
// import Slider from "react-slick";
import { Carousel, Modal } from 'react-bootstrap';
import { useSwipeable } from 'react-swipeable';



const currentUser = "Rose Winslet"; // Replace with actual logged-in user

const posts = [
  {
    id: 1,
    type: "post", // Regular post
    username: "Rose Winslet",
    timeAgo: "2d ago",
    profilePic: profilePicf, // Replace with actual profile picture URL
    image: [post1, post6, post7], // Replace with actual post image
    caption: "I captured this photograph yesterday morning. The birds were quite happy as they found an insect and shared it among themselves. It was a delightful and surprising moment to witness!",
    link: "https://500px.com/photo/81008519/birds-eating-insect",
    likes: "851",
    comments: "425",
    shares: "68",
  },
  {
    id: 2,
    type: "event", // Regular post
    username: "Rock Music Club",
    timeAgo: "2d 6h 42m remaining",
    profilePic: profilePicC, // Replace with actual profile picture URL
    image: [post3], // Replace with actual post image
    caption: "I captured this photograph yesterday morning. The birds were quite happy as they found an insect and shared it among themselves. It was a delightful and surprising moment to witness!",
    link: "https://500px.com/photo/81008519/birds-eating-insect",
    likes: "721",
    comments: "425",
    shares: "68",
    eventTitle: "Live Rock Concert - The Ultimate Experience", // Add this field!
    eventCreate: "Robert Brown",
    eventCreatePost: "Club member"
  },
  {
    id: 3,
    type: "poll", // Poll post
    username: "John doe",
    timeAgo: "2d 6h 42m remaining",
    profilePic: profilePicm,
    image: [post2],
    caption: "Which camera is best for general travel photography?",
    link: "https://500px.com/photo/12345678/nature-sunset",
    likes: "982",
    comments: "320",
    shares: "45",
    pollOptions: [
      { id: 1, option: "Canon EOS R6", votes: 320 },
      { id: 2, option: "Sony A7 IV", votes: 450 },
      { id: 3, option: "Nikon Z6 II", votes: 212 },
    ],
  },
  {
    id: 4,
    type: "event", // Regular post
    username: "Pulp Music Club",
    timeAgo: "Jhon Doe (Club member)",
    profilePic: profilePicd, // Replace with actual profile picture URL
    image: [post5], // Replace with actual post image
    caption: "I captured this photograph yesterday morning. The birds were quite happy as they found an insect and shared it among themselves. It was a delightful and surprising moment to witness!",
    link: "https://500px.com/photo/81008519/birds-eating-insect",
    likes: "221",
    comments: "325",
    shares: "78",
    eventTitle: "New year's eve party", // Add this field!
    eventCreate: "Rose Winslet",
    eventCreatePost: "Club member"
  },
  {
    id: 5,
    type: "event", // Regular post
    username: "Soft Music Club",
    timeAgo: "2d 6h 42m remaining",
    profilePic: profilePicC, // Replace with actual profile picture URL
    image: [post4], // Replace with actual post image
    caption: "I captured this photograph yesterday morning. The birds were quite happy as they found an insect and shared it among themselves. It was a delightful and surprising moment to witness!",
    link: "https://500px.com/photo/81008519/birds-eating-insect",
    likes: "221",
    comments: "325",
    shares: "78",
    eventTitle: "Live Party - The Ultimate Experience", // Add this field!
    eventCreate: "Jhon Doe",
    eventCreatePost: "Club member"
  },
];

const Post = ({ post, onDelete }) => {
  const [index, setIndex] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedPollOptions, setSelectedPollOptions] = useState({});
  const [isInterested, setIsInterested] = useState(false); // Toggle state
  const { isAuthenticated } = useAuth();
  const [showConfirm, setShowConfirm] = useState(false);

  // Handle Delete Button Click
  const handleDeleteClick = () => {
    setShowConfirm(true); // Show confirmation modal
  };

  // Handle Confirm Delete
  // const confirmDelete = () => {
  //   onDelete(post.id); // Call delete function
  //   setShowConfirm(false); // Close modal
  //   setMenuOpen(false); // Close menu
  // };

  // Handle Confirm Delete
  const confirmDelete = () => {
    if (typeof onDelete === "function") {
      onDelete(post.id); // Call the delete function
    } else {
      console.error("onDelete is not defined or not a function.");
    }
    setShowConfirm(false); // Close modal
    setMenuOpen(false); // Close menu
  };

  const handleInterestedToggle = () => {
    setIsInterested(!isInterested); // Toggle state
  };
  const handlePollSelection = (postId, optionId) => {
    setSelectedPollOptions((prev) => ({ ...prev, [postId]: optionId }));
  };
  const [isBooked, setIsBooked] = useState(false);

  const handleBooking = () => {
    setIsBooked(true); // Change text to "Booked" on click
  };

  const [loved, setLoved] = useState(false);
  const [commentsOpen, setCommentsOpen] = useState(false); // Track visibility
  const [searchText, setSearchText] = useState("");

  // const sliderSettings = {
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: false,
  //   fade: true,           // Enable fade-in effect
  //   cssEase: "linear",    // Ensure smooth fade effect
  // };

  const handlers = useSwipeable({
    onSwipedLeft: () => handleSelect(index + 1),
    onSwipedRight: () => handleSelect(index - 1),
    preventDefaultTouchmoveEvent: true,
    trackTouch: true,
    trackMouse: true,
  });

  const handleSelect = (selectedIndex) => {
    if (selectedIndex < 0) {
      setIndex(post.image.length - 1);
    } else if (selectedIndex >= post.image.length) {
      setIndex(0);
    } else {
      setIndex(selectedIndex);
    }
  };

  return (
    <div className="post-wraper">

      <div className="post">
        {/* Header Section */}
        <div className="post-header">
          <div className="profile-image"><img src={post.profilePic} alt="Profile" className="profile-pic" /></div>
          <div className="profile-text">
            <h4>{post.username}</h4>
            <p className="time-ago">
              {post.type === "post" ? (
                post.timeAgo
              ) : post.type === "poll" ? (
                <>
                  <BsStopwatch /> {post.timeAgo}
                </>
              ) : post.type === "event" ? (
                <>
                  <span className="event-create">{post.eventCreate}</span> <span className="event-create-post">({post.eventCreatePost})</span>
                </>
              ) : null}
            </p>

          </div>
          {/* Show Edit/Delete Menu Only for Logged-in User's Posts */}
          {/* Menu Button */}
          {(post.username === currentUser || post.eventCreate === currentUser) && (
            <div className="menu-container">
              <button disabled={!isAuthenticated} className="menu-button" onClick={() => setMenuOpen(!menuOpen)}>
                ⋮
              </button>
              {menuOpen && (
                <div className="menu-dropdown">
                  <div className="menu-item">
                    <LuPen /> Edit
                  </div>
                  <div className="menu-item delete" onClick={handleDeleteClick}>
                    <RiDeleteBin6Line /> Delete
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Confirmation Modal */}
          <Modal size="sm" show={showConfirm} onHide={() => setShowConfirm(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body className="delete-modal-body">
              <p>Are you sure you want to delete this post?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="link" onClick={() => setShowConfirm(false)}>
                No
              </Button>
              <Button variant="primary" onClick={confirmDelete}>
                Yes, Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>

        {/* Post Image */}
        {/* <div className="post-image">
          {post.image.length > 1 ? (
            <Slider {...sliderSettings}>
              {post.image.map((imgSrc, index) => (
                <div key={index}>
                  <img src={imgSrc} alt={`Post ${index + 1}`} className="post-img" />
                </div>
              ))}
            </Slider>
          ) : (
            <img src={post.image[0]} alt="Post" className="post-img" />
          )}
        </div> */}



        <div className="post-image" {...handlers}> {/* Apply swipe handlers to the wrapper */}
          {post.image.length > 1 ? (
            <Carousel activeIndex={index} onSelect={setIndex} interval={5000} touch={true} pause="hover" fade>
              {post.image.map((imgSrc, i) => (
                <Carousel.Item key={i}>
                  <img src={imgSrc} alt={`Post ${i + 1}`} className="d-block w-100 post-img" />
                </Carousel.Item>
              ))}
            </Carousel>
          ) : (
            <img src={post.image[0]} alt="Post" className="d-block w-100 post-img" />
          )}
        </div>


        {/* Event Details (If it's an Event) */}
        {post.type === "event" && (
          <div className="event-stack-details">
            <p><strong><MdDateRange />Feb 04, 2025 | 05:00 PM</strong></p>
            <p><strong><BsFillPeopleFill />55 Seats Available</strong>  | <strong>44 Going</strong></p>
          </div>
        )}


        {/* Caption Section */}
        <div className="caption">
          {post.type === "event" && (
            <h4>{post.eventTitle}</h4>
          )}
          <p>{post.caption}</p>
        </div>

        {/* poll Section */}
        {/* Poll Options (if post type is "poll") */}
        <div className="poll-items-wraper">
          {post.pollOptions && Array.isArray(post.pollOptions) && post.pollOptions.length > 0 &&
            post.pollOptions.map((option) => (
              <div
                key={option.id}
                className={`poll-items ${selectedPollOptions[post.id] === option.id ? "selected" : ""}`}
                onClick={() => isAuthenticated && handlePollSelection(post.id, option.id)}
              >
                <div className="d-flex align-items-center">
                  <label className="square-radio">
                    <input
                      type="radio"
                      checked={selectedPollOptions[post.id] === option.id}
                      onChange={() => isAuthenticated && handlePollSelection(post.id, option.id)}
                      disabled={!isAuthenticated}
                    />
                    <span></span>
                  </label>
                  <span className={`radio-label ${!isAuthenticated ? "disabled" : ""}`}>{option.option}</span>
                </div>
                <span className="poll-label">{option.votes} Votes</span>
              </div>
            ))
          }
        </div>

        {/* Event Buttons (Only for event) */}
        {isAuthenticated && post.eventCreate !== currentUser && post.type === "event" && (
          <div className="event-actions">
            <Button
              disabled={!isAuthenticated || isBooked} // Disable if not authenticated OR already booked
              className={`custom-booking-button ${isBooked ? "booked" : ""}`}
              onClick={handleBooking}
            >
              <span className="price">$20.50</span>
              <span className="label">
                {isBooked ? (
                  <>
                    <GrCheckmark /> Booked
                  </>
                ) : (
                  "Book a Seat"
                )}
              </span>
            </Button>
            {/* Interested Button with Toggle Effect */}
            <Button
              disabled={!isAuthenticated}
              variant={isInterested ? "interest" : "interest"}
              onClick={handleInterestedToggle}
            >
              {isInterested ? <><FaStar /> Interested</> : "Show Interest"}
            </Button>
          </div>
        )}

        {isAuthenticated && post.eventCreate === currentUser && post.type === "event" && (
          <div className="event-details">
            {/* Price Tag */}
            <div className="price-tag">
              <IoLogoUsd />
              <span>$20.50</span>
            </div>

            {/* Ticket & Interest Info */}
            <div className="event-stats">
              {/* Tickets Sold */}
              <div className="event-card">
                <div className="event-icon">
                  <IoTicket />
                </div>
                <div className="event-info">
                  <p className="event-number">42 Tickets Sold</p>
                  <Link to="/" className="view-members">View members <LiaAngleRightSolid /></Link>
                </div>
              </div>

              {/* People Interested */}
              <div className="event-card">
                <div className="event-icon">
                  <IoPeople />
                </div>
                <div className="event-info">
                  <p className="event-number">166 People Interested</p>
                  <Link to="/" className="view-members">View members <LiaAngleRightSolid /></Link>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Link Section */}
        {/* <div className="post-link">
          <FaLink className="link-icon" />
          <a href={post.link} target="_blank" rel="noopener noreferrer">
            {post.link}
          </a>
        </div> */}

        {/* Actions Section */}
        <div className="post-actions">
          {/* Love Button */}
          <div className="items">
            <Button
              disabled={!isAuthenticated} // Only enable if authenticated
              variant="link"
              className="p-0 no-underline action-button d-flex align-items-center"
              onClick={() => setLoved(!loved)}
            >
              <IoHeartCircle className="icon" />
              <span>{loved ? parseInt(post.likes) + 1 : post.likes} <span className="item-text">Loves</span></span>
            </Button>
          </div>

          {/* Comment Button */}
          <div className="items">
            <Button
              disabled={!isAuthenticated} // Only enable if authenticated
              variant="link"
              className="p-0 no-underline action-button d-flex align-items-center"
              onClick={() => setCommentsOpen(!commentsOpen)}
            >
              <IoChatbox className="icon" />
              <span>{post.comments} <span className="item-text">Comments</span></span>
            </Button>
          </div>

          {/* Share Button */}
          <div className="items d-flex align-items-center">
            <span>
              <span className="item-text">{post.shares} Times Shared</span>
            </span>
            <Button
              disabled={!isAuthenticated} // Only enable if authenticated
              variant="outline-secondary"
              className="br-10 share-button"
            >
              <FaShare className="icon" />
              Share
            </Button>
          </div>
        </div>

        {/* Comment Box - Controlled by commentsOpen */}
        <div className={`comment-box ${commentsOpen ? "show" : "hide"}`}>
          <input
            type="text"
            placeholder="Add your comment here"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          <Button variant="secondary" className={`search-button ${searchText ? "active" : ""}`}>
            <IoPaperPlane />
          </Button>
        </div>
      </div>
    </div>
  );
};

const PostList = ({ filterByUser, filterByType, filterByEventCreate }) => {
  // Ensure `filterByType` is an array for multiple types
  const filterTypes = Array.isArray(filterByType) ? filterByType : [filterByType];

  // Filter posts based on provided filters
  const filteredPosts = posts.filter(
    (post) =>
      (!filterByType || filterTypes.includes(post.type)) && // Allow multiple types
      (!filterByUser || post.username === filterByUser) && // Filter by user if provided
      (!filterByEventCreate || post.eventCreate === filterByEventCreate) // Check event creator
  );

  return (
    <div className="post-list">
      {filteredPosts.length > 0 ? (
        filteredPosts.map((post) => <Post key={post.id} post={post} />)
      ) : (
        <p>No posts found.</p>
      )}
    </div>
  );
};


export default PostList;
